import { useEffect } from 'react';
import './app.css';
import '@ant-design/v5-patch-for-react-19';
import { Layout } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import NavMenu from '@components/nav-menu/nav-menu';
import Auth from '@components/auth/auth';
// import Main from '@components/main/main';
import Vk from '@components/auth/vk';
import Tasks from '@components/tasks/tasks';
import Orders from '@components/orders/orders';
import Company from '@components/company/company';
import Manage from '@components/manage/manage';
import Licenses from '@components/licenses/licenses';
import Packets from '@components/packets/packets';
import Companies from '@components/companies/companies';
import Settings from '@components/settings/settings';
import Messages from '@components/messages/messages';
import Support from '@components/support/support';
import OrderDoc from '@components/orders/order-doc';


const App = () =>  {
  const routeItem = (obj) => <div className='main-content'><NavMenu /><div className='main-content__body'>{obj}</div></div>
  const user = useSelector((s) => s.user);
  const d = useDispatch();

  useEffect(() => {
    const url = new URL(window.location.href);
    const extraAuthId = url.searchParams.get('extraAuthId');
    if (!extraAuthId) return;

    localStorage.setItem('extraAuthId', extraAuthId);
    url.searchParams.delete('extraAuthId');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }, []);

  

  const router = createBrowserRouter([
    // { path: "/", element: routeItem(<Main />), },
    { path: "/doc/:code", element: <OrderDoc /> },
    { path: "/vk", element: routeItem(<Vk />), },
    { path: "/tasks", element: routeItem(<Tasks />), },
    { path: "/tasks/users", element: routeItem(<Tasks />), },
    { path: "/tasks/resources", element: routeItem(<Tasks />), },
    { path: "/orders", element: routeItem(<Orders />), },
    { path: "/orders/:id", element: routeItem(<Orders />), },
    { path: "/", element: routeItem(<Company />), },
    // { path: "/company", element: routeItem(<Company />), },
    { path: "/manage", element: routeItem(<Manage />), },
    { path: "/licenses", element: routeItem(<Licenses />), },
    { path: "/licenses/orders", element: routeItem(<Licenses />), },
    { path: "/licenses/keys", element: routeItem(<Licenses />), },
    { path: "/packets", element: routeItem(<Packets />), },
    { path: "/companies", element: routeItem(<Companies />), },
    { path: "/settings", element: routeItem(<Settings />), },
    { path: "/settings/pays", element: routeItem(<Settings />), },
    { path: "/settings/tags", element: routeItem(<Settings />), },
    { path: "/settings/banners", element: routeItem(<Settings />), },
    { path: "/messages", element: routeItem(<Messages />), },
    { path: "/messages/dialogs", element: routeItem(<Messages />), },
    { path: "/messages/clients", element: routeItem(<Messages />), },
    { path: "/messages/tokens", element: routeItem(<Messages />), },
    { path: "/support", element: routeItem(<Support />), },
    { path: "/support/:spaceId", element: routeItem(<Support />), },
    { path: "/plugins", element: routeItem(<Support />), },
    { path: "/plugins/:pluginId", element: routeItem(<Support />), },
  ])

  if (window.location.pathname === "/vk") return <Vk />
  if (!user && !window.location.pathname.startsWith("/doc")) return <Auth />
 

  return<div><RouterProvider router={router} notFound={<p>'Custom not found'</p>}>    
    <Layout style={{ minHeight: '100vh', width: '100%', maxWidth: '100%', margin: 0 }} />
    </RouterProvider>
  </div>
}

export default App;
